import { render, staticRenderFns } from "./ViewVehicle.vue?vue&type=template&id=1162ceb8"
import script from "./ViewVehicle.vue?vue&type=script&lang=js"
export * from "./ViewVehicle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports